import initialState from './initialState';
import * as types from '../constants/actionTypes';

export default (state = initialState.userSearchSettingReducer, action) => {
  const { payload } = action;

  switch (action.type) {
    case types.GET_COMMON_USER_SEARCH_SETTING_REQUEST:
      return state.set('isLoading', true);
    case types.GET_COMMON_USER_SEARCH_SETTING_FAILURE:
      return state.set('isLoading', false).set('isError', true);
    case types.GET_COMMON_USER_SEARCH_SETTING_SUCCESS:
      return state.set('isLoading', false).set('isError', false).set('isAlreadyGetSuccess', true).set('data', payload.data);
    case types.USER_LOGOUT_SUCCESS: {
      state = initialState.userSearchSettingReducer;
      return state;
    }
    default:
      return state;
  }
};
